import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000';

/**
 * Get user's transaction column preferences
 */
export const getTransactionColumnPreferences = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE}/api/users/transaction-column-preferences`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.success) {
      return response.data.preferences || null;
    }
    return null;
  } catch (error) {
    console.error('Error fetching transaction column preferences:', error);
    // Return null if preferences don't exist (not an error)
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

/**
 * Save user's transaction column preferences
 */
export const saveTransactionColumnPreferences = async (preferences) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(
      `${API_BASE}/api/users/transaction-column-preferences`,
      { preferences },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data.success) {
      return response.data.preferences;
    }
    throw new Error(response.data.message || 'Failed to save preferences');
  } catch (error) {
    console.error('Error saving transaction column preferences:', error);
    throw error;
  }
};

/**
 * Get user's transaction filter presets
 */
export const getTransactionFilterPresets = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE}/api/users/transaction-filter-presets`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.success) {
      return response.data.presets || [];
    }
    return [];
  } catch (error) {
    console.error('Error fetching filter presets:', error);
    // Return empty array if presets don't exist (not an error)
    if (error.response?.status === 404) {
      return [];
    }
    throw error;
  }
};

/**
 * Save user's transaction filter presets
 */
export const saveTransactionFilterPresets = async (presets) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(
      `${API_BASE}/api/users/transaction-filter-presets`,
      { presets },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.data.success) {
      return response.data.presets;
    }
    throw new Error(response.data.message || 'Failed to save filter presets');
  } catch (error) {
    console.error('Error saving filter presets:', error);
    throw error;
  }
};

export default {
  getTransactionColumnPreferences,
  saveTransactionColumnPreferences,
  getTransactionFilterPresets,
  saveTransactionFilterPresets
};

